import { render, staticRenderFns } from "./MyEmergencyPage.vue?vue&type=template&id=7b5cf112&scoped=true&"
import script from "./MyEmergencyPage.vue?vue&type=script&lang=ts&"
export * from "./MyEmergencyPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyEmergencyPage.vue?vue&type=style&index=0&id=7b5cf112&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5cf112",
  null
  
)

export default component.exports